import React from 'react';
import TrainingBenefitsMain from '../training/training-benefits/TrainingBenefitsMain';

const TrainingBenefits = ({ module }) => {
  return <TrainingBenefitsMain fields={module.fields} />;
};

export default TrainingBenefits;
